export default __webpack_public_path__ + "static/media/background.093b2168.png";